import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { isNative } from "@/lib/native";
import Landing from "@/pages/Landing";
import ThankYou from "@/pages/ThankYou";
import Access from "@/pages/Access";
import AdminStats from "@/pages/AdminStats";
import Community from "@/pages/Community";
import AdminCommunity from "@/pages/AdminCommunity";
import AdminPrompts from "@/pages/AdminPrompts";
import VideoGuides from "@/pages/VideoGuides";
import About from "@/pages/About";
import License from "@/pages/License";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import RefundPolicy from "@/pages/RefundPolicy";
import RecoverAccess from "@/pages/RecoverAccess";
import CookieConsent from "@/components/CookieConsent";
import ScrollToTop from "@/components/ScrollToTop";
import CookiePolicy from "@/pages/CookiePolicy";
import Accessibility from "@/pages/Accessibility";
import GetStarted from "@/pages/GetStarted";
import FreePlanner from "@/pages/FreePlanner";
import AdhdDailyPlanner from "@/pages/AdhdDailyPlanner";
import AdhdOverwhelm from "@/pages/AdhdOverwhelm";
import AdhdPlannerNoSubscription from "@/pages/AdhdPlannerNoSubscription";
import WhatToDoNext from "@/pages/WhatToDoNext";
import Today from "@/pages/Today";
import Settings from "@/pages/Settings";
import RouteSeo from "@/lib/seo";

// App Store / Play Store compliance: the native app must be free and login-only,
// with no in-app purchase of the $17 digital unlock. Any marketing or checkout
// surface is redirected to the login-gated Today screen when running on device.
// The purchase still happens on the web. On web, these render normally.
const WebOnly = ({ children }) => (isNative() ? <Navigate to="/today" replace /> : children);

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <ScrollToTop />
        <RouteSeo />
        <Routes>
          <Route path="/" element={<WebOnly><Landing /></WebOnly>} />
          <Route path="/thank-you" element={<WebOnly><ThankYou /></WebOnly>} />
          <Route path="/access/:token" element={<Access />} />
          <Route path="/admin/stats" element={<AdminStats />} />
          <Route path="/community" element={<Community />} />
          <Route path="/admin/community" element={<AdminCommunity />} />
          <Route path="/admin/prompts" element={<AdminPrompts />} />
          <Route path="/guides" element={<VideoGuides />} />
          <Route path="/about" element={<About />} />
          <Route path="/license" element={<License />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/get-started" element={<WebOnly><GetStarted /></WebOnly>} />
          <Route path="/free-planner" element={<WebOnly><FreePlanner /></WebOnly>} />
          <Route path="/adhd-daily-planner" element={<WebOnly><AdhdDailyPlanner /></WebOnly>} />
          <Route path="/adhd-overwhelm" element={<WebOnly><AdhdOverwhelm /></WebOnly>} />
          <Route path="/adhd-planner-no-subscription" element={<WebOnly><AdhdPlannerNoSubscription /></WebOnly>} />
          <Route path="/what-should-i-do-next" element={<WebOnly><WhatToDoNext /></WebOnly>} />
          <Route path="/recover-access" element={<RecoverAccess />} />
          <Route path="/today" element={<Today />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
